import { Button } from '../../components';
import React from 'react';
import { SessionService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import  '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchChannelList: any;
  setOverlay: any;
  status: any;
}
const SessionManagementBlocked: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    setOverlay,
    fetchChannelList,
    status,
  } = props;

  const [blocked, setBlocked] = React.useState(false);
  const blockService = () => {
    setOverlay(true);
    SessionService.block(id, status === 'blocked' ? 'blocked' : 'active').then(() => {
      setBlocked(true);
      setOverlay(false);
    });
  };

  return (
    <>
      {!blocked ? (
        <>
          <div>
            <img src={warning} alt="warning" />
            <h2>
              {status === 'blocked' ? 'Block' : 'Unblock'}
              {' '}
              Session
            </h2>
            <p>
              Are you sure you want to
              {' '}
              {status === 'blocked' ? 'block' : 'unblock'}
              {' '}
              this session?
            </p>
            <div className="modalButtonWrapper">
              <Button onClick={handleModalClose}>No</Button>
              <Button intent={status === 'blocked' ? 'danger' : 'primary'} onClick={blockService}>Yes</Button>
            </div>
          </div>
        </>
      ) : (
        <>
          <h3>
            Session
            {' '}
            {status === 'blocked' ? 'blocked' : 'unblocked'}
            {' '}
            successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchChannelList({
              page: 0,
              rowsPerPage: 10,
            });
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default SessionManagementBlocked;
